import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles((theme) => ({
  carregando: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 20,
  },
  fieldGroup: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(1),
    marginTop: 20,
  },
  item: {
    marginTop: theme.spacing(1),
    paddingLeft: '10px',
    paddingRight: '10px',
  },
  labelInput: {
    fontSize: '16px',
  },
}))

export default useStyles
